//@ts-check
import React from 'react';
import MultiSelectFormInput from '../MultiSelect';
import { useFilterContext } from './FilterContext';
/**
 * @param {import('./types').FormInputFilterExpressionFieldProps } props
 */

var FilterExpressionFieldFormInput = React.forwardRef(function (_ref, ref) {
  var value = _ref.value,
      onChange = _ref.onChange;

  var _useFilterContext = useFilterContext(),
      schema = _useFilterContext.schema,
      disabled = _useFilterContext.disabled,
      variant = _useFilterContext.variant,
      color = _useFilterContext.color;
  /**@type {import('../MultiSelect/types').MultiSelectGroupOptions[]} */


  var options = schema.Groups.map(function (group) {
    return {
      label: group.Name,
      options: group.Fields.map(function (field) {
        return {
          label: field.Caption,
          value: field.Name
        };
      })
    };
  });
  return React.createElement(MultiSelectFormInput, {
    ref: ref,
    value: value,
    onChange: onChange,
    disabled: disabled,
    variant: variant,
    options: options,
    color: color
  });
});
FilterExpressionFieldFormInput.defaultProps = {};
export default React.memo(FilterExpressionFieldFormInput);